<template>
    <div class="text_modal_wrapper">
        <div class="modal_bg"></div>
        <div class="text_modal">
            <img @click="closeModal" v-if="sendStage !== 'waiting'"  class="close_img" src="@/assets/images/qrpay_close.svg" alt="x" />
            <div style="clear:both"></div>

            <h3>{{ title }}</h3>
            <div class="text" v-html="text"></div>
        </div>            
    </div>
</template>

<script>
import Button from '@/components/Button.vue'
import ConfirmationInput from './ConfirmationInput.vue'

export default {
    name: "TextModal",
    props: ['title', 'text'],
    components: {
        Button,
        ConfirmationInput
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')      
        },
        sendPayment () {
        }
    }
}
</script>

<style>

</style>